import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators ,NgForm} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Console } from 'console';
import { Observable, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { documentType, ParentParameters, statusCode,applicationFrom } from '../../../auth/models/commonEnum';
import { AuthenticationService, CommonService } from '../../../auth/service';
import { MyApplicationService } from '../my-application.service';

@Component({
	selector: 'common-application-list',
	templateUrl: './application-list.component.html',
	styleUrls: ['./application-list.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ApplicationListComponent implements OnInit {
	 @Input()fromPageType:any| undefined;
	@ViewChild('profileDatabtn') myButton : ElementRef;
	@ViewChild('formDirective') formDirective: NgForm;
	hideButton: boolean = false;
	private targetDate = new Date('2025-09-05T23:59:00');
	public searchform: FormGroup;
	public forwordtoexpertform: FormGroup;
	public acceptRejectExpertComments:FormGroup;
	public uploadsigneddocumentform: FormGroup;
	public uploaddocumentform: FormGroup;
	public expertevalutionform: FormGroup;
	public approverejectform: FormGroup;
	public approverejectApplicationform: FormGroup;
	public uploadsanctionlatterform: FormGroup;
	public raiseRequestform: FormGroup;
	public sendMessageform: FormGroup;
	public progressapproveRejectform: FormGroup;
	public meetingAgendaForm : FormGroup;
	public loading = false;
	public returnUrl: string;
	public submitted = false;
	public isDisabled = false;
	public pageAdvancedEllipses = 1;
	public pageAdvancedNoEllipses = 8;
	public MinMaxDPdata: NgbDateStruct;
	public totalRating = 0;
	public details: any;
	public MOMFiles: any = [];
	public PMCFiles: any = [];
	public reviewReportStatus: any = [];
	public reviewList: any = [];
	public progreeReportDetailsForm: FormGroup;
	public pageSizeList = [
		{ pageSizeValue: "10" },
		{ pageSizeValue: "25" },
		{ pageSizeValue: "50" },
		{ pageSizeValue: "100" }
	];
	public sortByList = [
		{ sortByName: "Ascending", sortByValue: "ASC" },
		{ sortByName: "Descending", sortByValue: "DESC" }
	];
	public StatusList = [
		{ value: '1', label: 'Approved' },
		{ value: '2', label: 'Reject' }
	];
	public applicatinList = [];
	public projectType = [];
	public statusType = [];
	public subjectType = [];
	public stageType = [];
	public expertCategoryList = [];
	public expertListArray = [];
	public principalImplementing = [];
	public categoryOfInstitution = [];
	public expertCommentRatingList = [];
	public totalRecords: number;
	public pageSize: number;
	public dataLoading = false;
	public userInput = new Subject<string>();
	public selectedMovie: any;
	public minLengthTerm = 3;
	public documentFiles: any = [];
	public evalutionDocumentFiles: any = [];
	public isAdmin: boolean;
	public isExpert: boolean;
	public isUser: boolean;
	public canSubmitApplication: boolean;
	public currentUserId : any;
	public isProfile : any;
	public maxDate = this.calendar.getToday();
	public minDate = this.calendar.getPrev(this.calendar.getToday(), 'y', 10);
	public minDOBDate = this.calendar.getPrev(this.calendar.getToday(), 'y', 100);
	public endminDate = (this.minDate != undefined && this.minDate != null) ? this.minDate : this.calendar.getToday();
	public path: any;
	public applicationIds : any = [];
	public meetingAgendaUrl: String;
	public misUrl : String;
	public summaryUrl : String;
	private _unsubscribeAll: Subject<any>;
	public applicationFromMeetingAgenda : number;
	public applicationFromMyApplication : number;
	public applicationFromMisReport 	: number;
	public isDisplayButton : boolean;
	public element: HTMLElement;
	public updateProfileForm : FormGroup;
	public isShown: boolean ;
	public isShownRemark: boolean;
	public NewDate: any;
	public status : any;
	public getProfile : any;
	public profileDetails : any;
	public applicationDetail: any;
	public expertList: any;
	public tempEncodeId: any;
	public isViewMode: boolean | false;
	public manpowerArray: [];
	public prEquipmentDetailsArray: [];
	public sanctionDetails: object;
	public releasedCopyFiles: any [];
	public sanctionedAmount: any;
	public releasedAmount: number;
	public isReleasedAmountValid: number;
	public releasedOrderNo: any;
	public releasedDate: any;
	public releaseAmount: any;
	public sanctionData: any;
	public sanctionAmount: any;
	public messageDetail: any;
	public userNameToDisplay: any;
	public isAllowtoDoAction: any;
	public isShownRejectField: boolean;
	public isPRFormInvalid: boolean;
	public PRsanctionAmount: any;
	public summaryReportURL: any;
	public expertDocument: any;
	public addExpertForm: any;
	public departmentDataArray: any;
	public department: any[];
	public categoryDataArray: any;
	public CategoryType: any[];
	public categorySelectedIds: any;
	public expertSelectedId: any;
	public expertStatusSubmitted: any;
	public applicationStatusRemarksubmitted: any;
	public AreaofResearch: any;
	constructor(private _authenticationService: AuthenticationService,
		private _router: Router,
		private _myApplicationService: MyApplicationService,
		private _commonService: CommonService,
		private _formBuilder: FormBuilder,
		public formatter: NgbDateParserFormatter,
		private calendar: NgbCalendar,
		private http: HttpClient,
		private modalService: NgbModal,
		private datePipe: DatePipe) { 
			this._unsubscribeAll = new Subject();
			this.reviewReportStatus = [{ label: 'Approved', value: '1', checked:true }, { label: 'Reject', value: '2', checked:false }]
			this.searchform = this._formBuilder.group({
				ProjectType: [],
				PrincipalImplementingOrganizations: [],
				CategoryOfInstitution: [],
				SearchText: [''],
				ApplicationNumber:[''],
				Stage: [],
				Subject:[],
				Status:[],
				StartDate: [],
				EndDate: [,],
				SortOrder: ["DESC"],
				PageNumber: [1],
				PageSize: [10],
				institute:['']
			})
			this.forwordtoexpertform = this._formBuilder.group({
				Category: [],
				Expert: [, [Validators.required]],
				Remarks: [, [Validators.required]],
				Subject:[,[Validators.required]],
				department:[],
				ApplicationID: []
			});
			this.uploadsigneddocumentform = this._formBuilder.group({
				SignedDocument: [, [Validators.required]],
				SignedDocumentName: [],
				ApplicationID: [],
				summaryCheck: [false, Validators.requiredTrue]
			});
			this.approverejectform = this._formBuilder.group({
				StatusID: ['1'],
				Remarks: [, [Validators.required]],
				ApplicationID: [],
				applicationEncodedID :[]
			});
			this.approverejectApplicationform = this._formBuilder.group({
				StatusID: ['1'],
				Remarks: [, [Validators.required]],
				ApplicationID: []
			})
			this.uploadsanctionlatterform = this._formBuilder.group({
				SanctionLatter: [, [Validators.required]],
				SanctionLatterFileName: [],
				orderNo: [, [Validators.required, ]],
				sanctionAmount: [, [Validators.required]],
				releaseAmount:[, [Validators.required]],
				sanctionDate: [, [Validators.required]],
				ApplicationID: [],
				Rejectremarks : [,[Validators.required, ]],
				majorDeliverables:[]
			});
			this.raiseRequestform = this._formBuilder.group({
				requestStatus: [, [Validators.required]],
				requestRemark: [, [Validators.required]],
				ApplicationID: []
			});
			this.sendMessageform = this._formBuilder.group({
				messagetext: [, [Validators.required, ]],
				ApplicationID: []
			});
			this.progressapproveRejectform = this._formBuilder.group({
				PRorderNo: [null],
				PRamount: [0],
				PRdate: [null],
				MOMdocument: [null],
				MOMdocumentName: [null],
				PMCdocument: [null,[Validators.required]],
				PMCdocumentName: [null],
				releasedOrderCopy: [null],
				releasedOrderCopyName : [null],
				ApplicationID: [],
				progressReportId: [],
				SubjectArea: ['1',  [Validators.required]],
				PRremarks: [null,  [Validators.required]],
				SNamount:['']
			});
			this.uploaddocumentform = this._formBuilder.group({
				Document: [, [Validators.required]],
				DocumentName: [],
				ApplicationID: []
			});
			this.acceptRejectExpertComments = this._formBuilder.group({
				expertCommentsRemark:['',[Validators.required]],
				expertStatus:[,[Validators.required]],
				expertId:[,[Validators.required]],
				applicationID:[,[Validators.required]]
			})
		}
	 	ngOnInit() {
			this.checkTime();
		    setInterval(() => this.checkTime(), 1000);
			this.applicationFromMeetingAgenda = applicationFrom.MEETING_AGENDA;
			this.applicationFromMyApplication = applicationFrom.MY_APPLICATION;
			this.applicationFromMisReport = applicationFrom.MIS_REPORT;
			
			this._myApplicationService.onSettingsChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
				this.details = response;
			});
			this.expertevalutionform = this._formBuilder.group({
				ProjectTitle: [],
				EvalutionDocument: [],
				EvalutionDocumentName:["Select file"],
				Remarks: [, [Validators.required]],
				ApplicationID: [],
				expertEvalutionArray: this._formBuilder.array([
				])
			});
			this.loadSubjectAreaType();
			this.loadProjectTypeData();
			this.loadStatusType();
			this.loadStage();
			this.loadPrincipalImplementingData();
			this.loadCategoryImplementingData();
			this.loadSubjectType();
			this.getApplicationList();
			this.isAdmin = this._authenticationService.isAdmin;
			this.isExpert = this._authenticationService.isExpert;
			this.isUser = this._authenticationService.isUser;
			this.canSubmitApplication = this._authenticationService.currentUserValue.isApplyonline;
			this.currentUserId = this._authenticationService.currentUserValue.id;
			this.isProfile = this._authenticationService.currentUserValue.isProfileCreated;
			
			this.updateProfileForm = this._formBuilder.group({
				userId : [],
				title: [,[Validators.required, ]],
				dateOfBirth : [,[Validators.required]],
				department : [,[Validators.required, ]],
				designation : [,[Validators.required, ]],
				institute:[,[Validators.required, ]],
				gender: ['M', [Validators.required]]
			});
			
			this._myApplicationService.getProfileData().subscribe((result: any) => {
				this.getProfile = result;
				this.profileDetails = this.getProfile['data']['response'];
				if(this.profileDetails ==  undefined || (this.profileDetails.title == "" && this.profileDetails.dateOfBirth == "" && this.profileDetails.designation == "" && this.profileDetails.department == "")){
					this.triggerClick();
				}
			});

			this.progreeReportDetailsForm = this._formBuilder.group({
				projectTitle: [],
				NameOfPI: [],
				AddressOfPI: [],
				projectStartDate: [],
				projectEndDate: [],
				approvedBudget: [],
				sanctionNo: [],
				sanctionDate: [],
				sanctionAmount: [],
				actualExpenditure: [],
				approvedObjectivesProject: [],
				outputApprovedProject: [],
				summaryProgressReported: [],
				detailedProgress: [],
				newObservations: [],
				innovations: [],
				applicationPotential: [],
				projectAndWorkPlan: [],
				statusFinancialYearwise: [],
				applyonlineId: [],
				status: [],
				OtherDocument: [],
				TechnicalReport: [],
				UCletter: [],
				SOEletter: [],
			});
			this.applicationStatusRemarksubmitted = false;
			this.expertStatusSubmitted = false;
			this.submitted = false;
		}
		checkTime() {
			const now = new Date();
			this.hideButton = now >= this.targetDate;
		  }
		// ngAfterViewInit() {
		// 	this.triggerClick();
		// }

		triggerClick() {
			if(this.isProfile){
				setTimeout(() => {
					let el: HTMLElement = this.myButton.nativeElement as HTMLElement;
					el.click();
				}, 10);
			}
		}
	
	  	closeModal() {
			this.submitted = false;
		}
		/**
		 * function for open model popup for Approve/Reject application.
		 ***/
		actionOnExpertComment(modalAR, id, encodeId) {
			this.applicationStatusRemarksubmitted = false;
			this.getApplicationDetail(encodeId);
			this.approverejectform.reset();
			var applicationID = id;
				this.approverejectform.controls.StatusID.setValue('1');
				this.approverejectform.controls.ApplicationID.setValue(applicationID);
				this.approverejectform.controls.applicationEncodedID.setValue(encodeId);
				this.modalService.open(modalAR,{ 
					size: 'lg',
					scrollable: true,
					centered: true,
					backdrop: 'static',
				});
		}

		/**
		 * function for post approve/reject application details.
		 ***/
		approveRejectApplication(status,modal) {
			this.applicationStatusRemarksubmitted = true;
			if (this.approverejectform.invalid) {
				return false;
			}
			else {
				const data = {
					applyonlineId: this.approverejectform.value.ApplicationID,
					status: status,
					remark: this.approverejectform.value.Remarks
				}
				this.loading = true;
				this._myApplicationService.approveRejectApplication(data).pipe(first()).subscribe(
						response => {
							if (Number(response["statusCode"]) === statusCode.SUCCESS) {
								this.submitted = false;
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Record update successfully.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								this.approverejectform.reset();
								this.search();
								modal.close('Accept click');
							}
							else {
								this.loading = false;
								Swal.fire({
									icon: 'error',
									title: 'Error!',
									text: response["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);
				return false;
			}
		}

		/**
		 * function for open model popup for expert evalution.
		 ***/
		expertEvalution(modalExpertEvalution, id, title) {
			this.isViewMode = false;
			this.clearFormArray(<FormArray>this.expertevalutionform.controls['expertEvalutionArray']);
			this.expertevalutionform.reset();
			this.expertevalutionform.controls.EvalutionDocumentName.setValue("Select file");
			var applicationID = id;
			this.getExpertComments(applicationID, this.currentUserId);
			this.expertevalutionform.controls.ApplicationID.setValue(applicationID);
			this.expertevalutionform.controls.ProjectTitle.setValue(title);
			this.modalService.open(modalExpertEvalution, { size: 'xl', scrollable: true });
		}

		
		viewComment(modalExpertEvalution, id) {
			this.isViewMode = true;
			let expertID = id;
			this.getExpertComments(this.tempEncodeId, expertID);
			this.modalService.open(modalExpertEvalution, { size: 'xl', scrollable: true });
		}

		/**
		 * function for get expert evalution upload file on file upload change event.
		 ***/
		uploadEvalutionChange(event: any, fileSize:any) {
			for (var i = 0; i < event.target.files.length; i++) {
				var filetype = event.target.files[i].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				this.evalutionDocumentFiles = [];
				var key = "expertEvalutionDocument";
				this.evalutionDocumentFiles.push({ key: key, file: event.target.files[i] });
				this.expertevalutionform.controls.EvalutionDocumentName.setValue(this.showFiles(this.evalutionDocumentFiles));
			}
		}
		/**
		 * function for post expert evalution form data.
		 ***/
		postExpertEvalutionData(modal) {
			//modal.close('Accept click');
			var self = this;
			this.submitted = true;
			if (this.expertevalutionform.invalid) {
				return false;
			}
			else {
				let input: FormData = new FormData();
				let commentArray = [];
				if (this.expertevalutionform.value.expertEvalutionArray.length > 0) {
					this.expertevalutionform.value.expertEvalutionArray.forEach(element => {
						commentArray.push({
							applyonlineId: this.expertevalutionform.value.ApplicationID,
							itemId: element.parentid,
							comments: element.comments,
							rating: element.rating == 100 ? this.totalRating : element.givenRating
						})
					});
				}
				input.append('expertComments', JSON.stringify(commentArray));
				for (var i = 0; i < this.evalutionDocumentFiles.length; i++) {
					input.append(this.evalutionDocumentFiles[i].key, this.evalutionDocumentFiles[i].file);
				}
				input.append('remarks', this.expertevalutionform.value.Remarks);
				input.append('applyonlineId', this.expertevalutionform.value.ApplicationID);
				this.loading = true;
				this._myApplicationService
					.submitExpertEvalutionDetails(input)
					.pipe(first())
					.subscribe(
						response => {
							if (Number(response["statusCode"]) === statusCode.SUCCESS) {
								this.submitted = false;
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Expert Comments submitted successfully.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								this.clearFormArray(<FormArray>this.expertevalutionform.controls['expertEvalutionArray']);
								this.expertevalutionform.reset();
								this.totalRating = 0;
								// this.getExpertEvalutionDetail();
								this.search();
								modal.close('Accept click');
							}
							else {
								this.loading = false;
								Swal.fire({
									icon: 'error',
									title: 'Error!',
									text: response["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);
				return false;
			}
		}

		/**
		 * function for clear formarray data.
		 ***/
		clearFormArray = (formArray: FormArray) => {
			while (formArray.length !== 0) {
				formArray.removeAt(0)
			}
		}

		/**
		 * function for get expert evalution details.
		 ***/
		// getExpertEvalutionDetail() {
		// 	this._commonService.getExpertCommentRatingList().subscribe((result: any) => {
		// 		this.expertCommentRatingList = [];
		// 		if (result.statusCode == statusCode.SUCCESS) {
		// 			result["data"]["response"].forEach(element => {
		// 				this.expertCommentRatingList.push({
		// 					parentPara: element.parentPara,
		// 					parentid: element.parentid,
		// 					rating: element.rating,
		// 					childPara: element.childPara
		// 				});
		// 				const expertEvalutionArray = <FormArray>this.expertevalutionform.controls['expertEvalutionArray'];
		// 				expertEvalutionArray.push(this.initExpertEvalutionRow(element.parentPara, element.parentid, element.rating, element.childPara));
		// 			});
		// 		}
		// 	})
		// }

		getExpertComments(applyonlineId, expertId:any) {
			const data = {
				expertId: (expertId > 0) ? expertId : this.currentUserId,
				applyonlineId: applyonlineId
			}
			
			this._myApplicationService.getExpertCommentByID(data).subscribe((result: any) => {
				this.clearFormArray(<FormArray>this.expertevalutionform.controls['expertEvalutionArray']);
				this.expertCommentRatingList = [];
				if (result.statusCode == statusCode.SUCCESS) {
					let index = 0;
					result["data"]["response"]["commentsDetails"].forEach(element => {
						this.expertCommentRatingList.push({
							parentPara: element.parentPara,
							parentid: element.parentid,
							comments: element.comments,
							givenRating: element.evolutionRating,
							rating: element.rating,
							childPara: element.childPara
						});
						
						const expertEvalutionArray = <FormArray>this.expertevalutionform.controls['expertEvalutionArray'];
						expertEvalutionArray.push(this.initExpertEvalutionRow(element.parentPara,
							element.parentid, element.rating, element.childPara,element.comments,element.evolutionRating));
						this.calculcateTotalRating(index);
						index++;
					});
					//this.totalRating = result["data"]["response"]['totalRating'];
					this.expertevalutionform.controls.Remarks.setValue(result["data"]["response"]["remark"]);
					this.expertDocument = result["data"]["response"]["expertEvalutionDocument"];
				}
			})
		}

		getReviewReport(id){
			const data = {
				applyonlineId: id
			}
			this._myApplicationService.getreviewReportDetails(data).subscribe((result: any) => {
				if (result.statusCode == statusCode.SUCCESS) {
					this.reviewList = result["data"]["response"];
				}
			})
			this._myApplicationService.getSanctionDetials(data).subscribe((result: any) => {
				if (result.statusCode == statusCode.SUCCESS) {
					this.sanctionData = result["data"]["response"];
					this.PRsanctionAmount = parseFloat(this.sanctionData.amount.replaceAll(",",""));
					this.progressapproveRejectform.controls.SNamount.setValue(this.PRsanctionAmount);
				}
			})
		}

		/**
		 * function for create expert evalution formarry.
		 ***/
		initExpertEvalutionRow(name: string, id: number, rating: number, childPara: [],comments:any,evolutionRating:any): FormGroup {
			return this._formBuilder.group({
				parentPara: [name],
				parentid: [id],
				rating: [rating],
				childPara: [childPara],
				comments: [(comments != '') ? comments : null,[ ]],
				givenRating: [ (evolutionRating > 0) ? evolutionRating : 0 ,(rating > 0 && rating != 100 ? [Validators.required, Validators.min(0), Validators.max(rating)] : [])],
				isDisabledField: [rating == 100 ? true : false]
			});
		}

		/**
		 * function for calculate total rating.
		 ***/
		calculcateTotalRating(index: number) {
			let total = 0;
			this.expertevalutionform.controls.expertEvalutionArray["controls"].forEach(element => {
				// let rating = parseInt((element.value.givenRating == null ? 0 : element.value.givenRating));
				let rating = (element.value.rating != 100) ? parseInt((element.value.givenRating == 0 ? 0 : element.value.givenRating)): 0;
				total = total + rating;
			});

			this.totalRating = total;
		}

		/**
		 * function for open modal popup forforward to expert data.
		 ***/
		forwardToExpert(modalVC, id) {
			this.submitted = false;
			this.forwordtoexpertform.reset();
			this.loadExpertCategory();
			var applicationID = id;
			this.forwordtoexpertform.controls.ApplicationID.setValue(applicationID);
			this.modalService.open(modalVC, {
				centered: true
			});
		}

		/**
		 * function for post/submit data.
		 ***/
		postData(modal) {
			//modal.close('Accept click');
			this.submitted = true;
			if (this.forwordtoexpertform.invalid) {
				return false;
			}
			else {
				const data = {
					expert_id: this.forwordtoexpertform.controls.Expert.value,
					remarks: this.forwordtoexpertform.controls.Remarks.value,
					applyonlineId: this.forwordtoexpertform.controls.ApplicationID.value
				}
				this._myApplicationService.forwardToExpert(data).pipe(first()).subscribe(
						result => {
							if (Number(result["statusCode"]) === statusCode.SUCCESS) {
								this.submitted = false;
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Application forward to the selected expert.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								modal.close('Accept click');
								this.modalService.dismissAll();
								this.search();
								// this._router.navigate([this.returnUrl]);
							}
							else {
								//this.error = result.message;
								this.loading = false;
								Swal.fire({
									icon: 'info',
									title: 'Info!',
									text: result["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							//this.error = error;
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);
				return false;
			}
		}

		/**
		 * function for open model popup for upload signed document.
		 ***/
		uploadSignedDocument(modalDC, id) {
			this.uploadsigneddocumentform.reset();
			this.uploadsigneddocumentform.controls.SignedDocumentName.setValue("Select file");
			var applicationID = id;
			this.uploadsigneddocumentform.controls.ApplicationID.setValue(applicationID);
			this.modalService.open(modalDC, {
				centered: true
			});
		}

		/**
		 * function for open model popup for upload document.
		 ***/
		 uploadDocument(modalUDC, id) {
			this.uploaddocumentform.reset();
			this.uploaddocumentform.controls.DocumentName.setValue("Select file");
			var applicationID = id;
			this.uploaddocumentform.controls.ApplicationID.setValue(applicationID);
			this.modalService.open(modalUDC, {
				centered: true
			});
		}

		/**
		 * function get uploaded file on upload file change.
		 ***/
		uploadFileChange(event: any, type, fileSize: any) {
			for (var i = 0; i < event.target.files.length; i++) {
				var filetype = event.target.files[i].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				this.documentFiles = [];
				var key = "document";
				this.documentFiles.push({ key: key, file: event.target.files[i] });
				if (type === 'document') {
					this.uploadsigneddocumentform.controls.SignedDocumentName.setValue(this.showFiles(this.documentFiles));
				}
				else if (type === 'uploaddocument') {
					this.uploaddocumentform.controls.DocumentName.setValue(this.showFiles(this.documentFiles));
				}
				else if (type === 'sanctionLatter') {
					this.uploadsanctionlatterform.controls.SanctionLatterFileName.setValue(this.showFiles(this.documentFiles));
				}
			}
		}
		/**
		 * function return selected file name.
		 ***/
		showFiles(documentsList: any) {
			let files = '';
			for (let i = 0; i < documentsList.length; i++) {
				files += documentsList[i].file.name;

				if (!(documentsList.length - 1 === i)) {
					files += ',';
				}
			}
			return files;
		}

		browsbuttonClick(type) {
			if (type === 'sanctionLatter') {
				this.uploadsanctionlatterform.controls.SanctionLatterFileName.setValue("Select file");
			}
			if (type === 'document') {
				this.uploadsigneddocumentform.controls.SignedDocumentName.setValue("Select file");
			}
			if (type === 'uploaddocument') {
				this.uploaddocumentform.controls.DocumentName.setValue("Select file");
			}
			if(type === 'expertEvalutionDocument'){
				this.expertevalutionform.controls.EvalutionDocumentName.setValue("Select file");
			}
		}
		/**
		 * function for upload signed document.
		 ***/
		uploadDocumentData(modal) {
			this.submitted = true;
			if (this.uploadsigneddocumentform.invalid) {
				return false;
			}
			else {
				let input: FormData = new FormData();
				input.append("applyonlineId", this.uploadsigneddocumentform.controls.ApplicationID.value);
				input.append("type", documentType.SignedDocument.toString());
				for (var i = 0; i < this.documentFiles.length; i++) {
					input.append(this.documentFiles[i].key, this.documentFiles[i].file);
				}
				this._myApplicationService
					.uploadSignedDocument(input)
					.pipe(first())
					.subscribe(
						response => {
							if (Number(response["statusCode"]) === statusCode.SUCCESS) {
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Your document is uploaded and proposal is submitted successfully.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								this.search();
								this.submitted = false;
								modal.close('Accept click');
							}
							else {
								this.loading = false;
								Swal.fire({
									icon: 'error',
									title: 'Error!',
									text: response["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);

				return false;
			}
		}

		uploadApplicationDocument(modal) {
			this.submitted = true;
			if (this.uploaddocumentform.invalid) {
				return false;
			}
			else {
				let input: FormData = new FormData();
				input.append("applyonlineId", this.uploaddocumentform.controls.ApplicationID.value);
				for (var i = 0; i < this.documentFiles.length; i++) {
					input.append(this.documentFiles[i].key, this.documentFiles[i].file);
				}
				this._myApplicationService
					.uploadDocument(input)
					.pipe(first())
					.subscribe(
						response => {
							if (Number(response["statusCode"]) === statusCode.SUCCESS) {
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Your document is uploaded successfully.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								this.search();
								this.submitted = false;
								modal.close('Accept click');
							}
							else {
								this.loading = false;
								Swal.fire({
									icon: 'error',
									title: 'Error!',
									text: response["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);

				return false;
			}
		}

		/**
		 * function for open model popup for upload sanction latter document.
		 ***/
		uploadSanctionLatter(modalSL, id) {
			this.isShown = false;
			this.isShownRemark = false;
			this.uploadsanctionlatterform.reset();
			this.uploadsanctionlatterform.controls.SanctionLatterFileName.setValue("Select file");
			var applicationID = id;
			this.uploadsanctionlatterform.controls.ApplicationID.setValue(applicationID);
			this.modalService.open(modalSL, {
				centered: true,
				backdrop: 'static',
				size: 'lg', scrollable: true
			});
		}
		
		/**
		 * function for upload Sanction latter document.
		 ***/
		uploadSanctionLatterDocumentData(modal) {
			console.log(this.uploadsanctionlatterform);
			this.submitted = true;
			if(this.isShown == true){
				this.status = 1;
			}else if(this.isShownRemark == true){
				this.status = 2;
			}
			if(this.uploadsanctionlatterform.invalid || this.isFormInvalid){
				return false;
			}else {
				var start_Date = this.uploadsanctionlatterform.controls.sanctionDate.value;
				this.NewDate = '';
				if(start_Date != undefined && start_Date != null){
					var Month 	= start_Date.month;
					this.NewDate = start_Date.year + '-' + Month + '-' + start_Date.day;
				}
				let input: FormData = new FormData();
				input.append("applyonlineId", this.uploadsanctionlatterform.controls.ApplicationID.value);
				input.append("type", documentType.SanctionLatter.toString());
				input.append("orderNo", this.uploadsanctionlatterform.controls.orderNo.value);
				input.append("sanctionAmount", this.uploadsanctionlatterform.controls.sanctionAmount.value);
				input.append("sanctionDate", this.NewDate);
				input.append("rejectRemark",this.uploadsanctionlatterform.controls.Rejectremarks.value);
				input.append("releaseAmount",this.uploadsanctionlatterform.controls.releaseAmount.value);
				input.append("majorDeliverables",this.uploadsanctionlatterform.controls.majorDeliverables.value);

				input.append("status",this.status);


				for (var i = 0; i < this.documentFiles.length; i++) {
					input.append(this.documentFiles[i].key, this.documentFiles[i].file);
				}
				this._myApplicationService
					.uploadSignedDocument(input)
					.pipe(first())
					.subscribe(
						response => {
							if (Number(response["statusCode"]) === statusCode.SUCCESS) {
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Your document for Sanction Letter has been uploaded successfully.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								this.search();
								modal.close('Accept click');
								this._router.navigate(['/my-application']);
							}
							else {
								this.loading = false;
								Swal.fire({
									icon: 'error',
									title: 'Error!',
									text: response["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);
				return false;
			}
		}

		/**
		 * function for set end Min data based on start date. 
		 ***/
		setEndMinDate() {
			if (this.searchform.controls.StartDate.value != undefined && this.searchform.controls.StartDate.value != null) {
				this.endminDate = (this.searchform.controls.StartDate.value != undefined && this.searchform.controls.StartDate.value != null)
					? this.searchform.controls.StartDate.value : this.calendar.getToday();
			} else {
				this.endminDate = (this.minDate != undefined && this.minDate != null) ? this.minDate : this.calendar.getToday();
			}
		}

		/**
		 * function for set start Min and reset end date if first selected. 
		 ***/
		setStartMinDate() {
			if (this.searchform.controls.EndDate.value != undefined && this.searchform.controls.EndDate.value != null) {
				//Reset End Date field
				this.searchform.controls.EndDate.setValue("");
			}
		}

		trackByFn(item: any) {
			return item.id;
		}
		/**
		 * function for load project type dropdown data.
		 ***/
		loadExpertCategory() {
			this._commonService.getParameterSettings(ParentParameters.EXPERT_CATEGORIES).subscribe((result: any) => {
				this.expertCategoryList = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.expertCategoryList.push({
							name: element.paraDescription,
							id: element.paraId
						});
					});
				}
			});
		}

		/**
		 * function for load project type dropdown data.
		 ***/
		loadProjectTypeData() {
			this._commonService.getParameterSettings(ParentParameters.PROJECTTYPE).subscribe((result: any) => {
				this.projectType = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.projectType.push({
							projectTypeName: element.paraDescription,
							projectTypeID: element.paraId
						});
					});
				}
			});
		}

		/**
		 * function for load status type dropdown data.
		 ***/
		 loadStatusType() {
			this._commonService.getParameterSettings(ParentParameters.APPLICATION_STATUS).subscribe((result: any) => {
				this.statusType = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.statusType.push({
							statusTypeName: element.paraDescription,
							statusTypeID: element.paraId
						});
					});
				}
			});
		}

		/**
		 * function for load status type dropdown data.
		 ***/
		 loadSubjectType() {
			this._commonService.getParameterSettings(ParentParameters.SUBJECTAREA).subscribe((result: any) => {
				this.subjectType = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.subjectType.push({
							subjectTypeName: element.paraDescription,
							subjectTypeID: element.paraId
						});
					});
				}
			});
		}

		/**
		 * function for load Stage type dropdown data.
		 ***/
		 loadStage() {
			this._commonService.getParameterSettings(ParentParameters.APPLYONLINE_STAGE).subscribe((result: any) => {
				this.stageType = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.stageType.push({
							stageTypeName: element.paraDescription,
							stageTypeID: element.paraId
						});
					});
				}
			});
		}

		/**
		 * function for load principal implementing dropdown data.
		 ***/
		loadPrincipalImplementingData() {
			this._commonService.getParameterSettings(ParentParameters.PRINCIPLIMPLEMENTING_APF1).subscribe((result: any) => {
				this.principalImplementing = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.principalImplementing.push({
							princialImplementingName: element.paraDescription,
							princialImplementingID: element.paraId
						});
					});
				}
			});
		}

		/**
		 * function for load category dropdown data.
		 ***/
		loadCategoryImplementingData() {
			this._commonService.getParameterSettings(ParentParameters.CATIMPLEMENTINGINSTITUTION_APF1).subscribe((result: any) => {
				this.categoryOfInstitution = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.categoryOfInstitution.push({
							categoryOfInstitutionName: element.paraDescription,
							categoryOfInstitutionID: element.paraId
						});
					});
				}
			});
		}

		/**
		 * function for get formate1 data.
		 ***/
		get f1() {
			return this.searchform.controls;
		}

		/**
		 * function for get formate2 data.
		 ***/
		get f2() {
			return this.forwordtoexpertform.controls;
		}

		/**
		 * function for get formate3 data.
		 ***/
		get f3() {
			return this.uploadsigneddocumentform.controls;
		}

		/**
		 * function for get formate4 data.
		 ***/
		get f4() {
			return this.expertevalutionform.controls;
		}

		/**
		 * function for get formate5 data.
		 ***/
		get f5() {
			return this.approverejectform.controls;
		}

		/**
		 * function for get formate6 data.
		 ***/
		get f6() {
			return this.uploadsanctionlatterform.controls;
		}
		/**
		 * function for get raise request data.
		 ***/
		get raiseRequestFormData() {
			return this.raiseRequestform.controls;
		}
		/**
		 * function for get send messages data.
		 ***/
		get messageFormData() {
			return this.sendMessageform.controls;
		}

		get f7() {
			return this.uploaddocumentform.controls;
		}
		/**
		 * function for bind my-application list data.
		 ***/
		getApplicationList() {
			this.search();
		}

		/**
		 * function for reset filter.
		 ***/
		resetFilter() {
			this.searchform.reset();
			this.search();
		}

		/**
		 * function for search data.
		 ***/
		search() {
			let defaultPageSize = this.searchform.controls.PageSize.value != undefined ? this.searchform.controls.PageSize.value : 10;
			let start_Date = this.searchform.controls.StartDate.value;
			if (start_Date != null && start_Date != undefined) {
				start_Date = start_Date.year + '-' + start_Date.month + '-' + start_Date.day;
			}
			let end_Date = this.searchform.controls.EndDate.value;
			if (end_Date != null && end_Date != undefined) {
				end_Date = end_Date.year + '-' + end_Date.month + '-' + end_Date.day;
			}
			const data = {
				projectType: this.searchform.controls.ProjectType.value,
				status:this.searchform.controls.Status.value,
				stage: this.searchform.controls.Stage.value,
				subject: this.searchform.controls.Subject.value,
				searchText: this.searchform.controls.SearchText.value,
				applicationNumber: this.searchform.controls.ApplicationNumber.value,
				principalImplementingOrganizations: this.searchform.controls.PrincipalImplementingOrganizations.value,
				categoryOfInstitution: this.searchform.controls.CategoryOfInstitution.value,
				startDate: start_Date,
				endDate: end_Date,
				sortOrder: (this.searchform.controls.SortOrder.value == null ? "DESC" : this.searchform.controls.SortOrder.value),
				pageNumber: this.previousPage != undefined ? this.previousPage : this.searchform.controls.PageNumber.value,
				pageSize: defaultPageSize,
				isMeetingAgenda : this.fromPageType,
				institute:this.searchform.controls.institute.value
			}

			this._myApplicationService.getApplicationList(data).subscribe((result: any) => {
				this.applicatinList = [];
				if (result.statusCode == statusCode.SUCCESS) {
					this.applicatinList = result["data"]["response"]["applicationDetails"];

					this.totalRecords = result["data"]["response"]["TotalCount"];
					this.pageSize = defaultPageSize;
				}
				else {
					this.totalRecords = 0;
					this.applicatinList = [];
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: result["message"],
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			});

		}


		getApplicationDetail(encodeId:any) {
			const data = {
				applyonlineId: encodeId
			}
			this._myApplicationService.getApplicationDetail(data).subscribe((result: any) => {
				this.applicationDetail = null;
				if (result.statusCode == statusCode.SUCCESS) {
					this.applicationDetail = result["data"]["response"];
					this.tempEncodeId = encodeId;
					this.expertList = this.applicationDetail.expert;
				}
			})
		}

	isfromMeetingAgenda(isfromMeetingAgenda: any) {
		throw new Error('Method not implemented.');
	}

		/**
		 * function for load data based on pagination.
		 ***/
		previousPage: any;
		loadPage(page: number) {
			if (page !== this.previousPage) {
				this.previousPage = page;
				this.search();
			}
		}

		downloadApplicationForm(id) {
			const data = {
				applyonlineId: id,
			}
			this._myApplicationService.downloadApplicationData(data).subscribe((result: any) => {
				this.path = result;
			});

			// let url = this._myApplicationService.downloadApplicationData(data);
			// var link = document.createElement('a');
			// link.href = url;
			// link.target = "_blank";
			// link.click();

		}

		downloadApplicationSummaryPdf(id) {
			const data = {
				applyonlineId: id,
			}
			this._myApplicationService.downloadApplicationSummaryData(data).subscribe((result: any) => {
				if (result.statusCode == statusCode.SUCCESS) {
					this.summaryUrl = result["data"]["response"];
					if(this.summaryUrl != null && this.summaryUrl != ""){
						//let misURL = "https://" + this.misUrl;
						let summaryUrl = this.summaryUrl.toString();
						
						window.open(summaryUrl);
					}
				}
				else {
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: result["message"],
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			});

			// let url = this._myApplicationService.downloadApplicationData(data);
			// var link = document.createElement('a');
			// link.href = url;
			// link.target = "_blank";
			// link.click();

		}

		/**
		 * function for open model popup for upload sanction latter document.
		 ***/
		raiseRequestAgenda(modalRR, id) {
			this.raiseRequestform.reset();
			var applicationID = id;
			this.raiseRequestform.controls.ApplicationID.setValue(applicationID);
			this.modalService.open(modalRR, {
				centered: true
			});
		}
		/**
		 * function for submit Raise request data.
		 ***/
		raiseRequestData(modal) {
			this.submitted = true;
			if (this.raiseRequestform.invalid) {
				return false;
			} else {
				const data = {
					requestStatus: this.raiseRequestform.controls.requestStatus.value,
					requestRemark: this.raiseRequestform.controls.requestRemark.value,
					applyonlineId: this.raiseRequestform.controls.ApplicationID.value
				}
				this._myApplicationService
					.raiseRequest(data)
					.pipe(first())
					.subscribe(
						result => {
							if (Number(result["statusCode"]) === statusCode.SUCCESS) {
								this.submitted = false;
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Request Raised Successfully.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								modal.close('Accept click');
							} else {
								this.loading = false;
								Swal.fire({
									icon: 'info',
									title: 'Info!',
									text: result["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);
				return false;
			}
		}
		/**
		 * function for open model popup for send message.
		 ***/
		sendMessage(modalSM, id) {
			this.sendMessageform.reset();
			this.isAllowtoDoAction = true;
			var applicationID = id;
			this.getMessageData(applicationID);
			this.sendMessageform.controls.ApplicationID.setValue(applicationID);
			this.modalService.open(modalSM, {
				size: 'lg',
				scrollable: true
			});
		}

		viewMessage(modalSM, id){
			this.sendMessageform.reset();
			var applicationID = id;
			this.isAllowtoDoAction = false;
			this.getMessageData(applicationID);
			this.sendMessageform.controls.ApplicationID.setValue(applicationID);
			this.modalService.open(modalSM, {
				size: 'lg',
				scrollable: true
			});
		}

		sendMessageData(modal) {
			this.submitted = true;
			if (this.sendMessageform.invalid) {
				return false;
			} else {
				const data = {
					messagetext: this.sendMessageform.controls.messagetext.value,
					ApplicationID: this.sendMessageform.controls.ApplicationID.value
				}
				this._myApplicationService
					.sendMessage(data)
					.pipe(first())
					.subscribe(
						result => {
							if (Number(result["statusCode"]) === statusCode.SUCCESS) {
								this.submitted = false;
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Message send Successfully.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								this.getMessageData(data.ApplicationID);
								this.sendMessageform.controls.messagetext.setValue('');
								//modal.close('Accept click');
							} else {
								this.loading = false;
								Swal.fire({
									icon: 'info',
									title: 'Info!',
									text: result["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);
				return false;
			}
		}
		getMessageData(applicationId){
			const data = {
				applicationID: applicationId
			}
			this._myApplicationService.getMessageData(data).subscribe((result: any) => {
				this.applicationDetail = null;
				if (result.statusCode == statusCode.SUCCESS) {
					this.messageDetail = result["data"]["messageDetails"];
					this.userNameToDisplay = result["data"]["userNameToDisplay"];
				}
			})
		}
		
		progressReportDetails(modalPR, progressReportId) {
			//this.progreeReportDetailsForm.reset();
			this.getprogressReportDetails(progressReportId);
			this.modalService.open(modalPR, { size: 'xl', scrollable: true });
		}

		getprogressReportDetails(progressReportId) {
			const data = {
				progressReportId: progressReportId
			}
			this._myApplicationService.getprogressReportDetail(data).subscribe((result: any) => {
				if (result.statusCode == statusCode.SUCCESS) {
					let progressReportDetail = result["data"]["response"].progressReportDetails;
					let manPowerDetail = result["data"]["response"].manPowerDetails;
					let sanctionDetail = result["data"]["response"].sanctionDetails;
					let prEquipmentDetails = result["data"]["response"].prEquipmentDetails;
					this.releasedOrderNo = progressReportDetail.releasedOrderNo;
					this.releasedDate = progressReportDetail.releasedDate;
					this.releaseAmount = progressReportDetail.releasedAmount;

					if (progressReportDetail != null && progressReportDetail.id > 0) {
						this.progreeReportDetailsForm.patchValue(progressReportDetail);
					}
					if (manPowerDetail.length > 0) {
						this.manpowerArray = manPowerDetail;
					}
					if (prEquipmentDetails.length > 0) {
						this.prEquipmentDetailsArray = prEquipmentDetails;
					}
					this.sanctionDetails = sanctionDetail;
				}
			})
		}

		/**
		 * function for open model popup for accept/reject review report.
		 ***/
		progressReportStatus(modalPR, id, progressReportId, encodeId) {
			this.progressapproveRejectform.reset();
			this.getReviewReport(encodeId);
			this.progressapproveRejectform.controls.PMCdocumentName.setValue("Select file");
			this.progressapproveRejectform.controls.MOMdocumentName.setValue("Select file");
			this.progressapproveRejectform.controls.releasedOrderCopyName.setValue("Select file");
			var applicationID = id;
			this.progressapproveRejectform.controls.ApplicationID.setValue(applicationID);
			this.progressapproveRejectform.controls.progressReportId.setValue(progressReportId);
			// this.modalService.open(modalPR, {
			// 	centered: true
			// });
			this.modalService.open(modalPR, { size: 'lg', scrollable: true, centered: true });
		}
		/**
		 * function for get progress report accept reject form data.
		 ***/
		get prForm() {
			return this.progressapproveRejectform.controls;
		}
		/**
		 * function get uploaded file on upload file change.
		 ***/
		uploadMOMfileChange(event: any, fileSize) {
			for (var i = 0; i < event.target.files.length; i++) {
				var filetype = event.target.files[i].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				this.MOMFiles = [];
				var key = "MOMfile";
				this.MOMFiles.push({ key: key, file: event.target.files[i] });
				this.progressapproveRejectform.controls.MOMdocumentName.setValue(this.showFiles(this.MOMFiles));
			}
		}

		/**
		 * function get uploaded file on upload file change.
		 ***/
		uploadPMCfileChange(event: any, fileSize:any,keyValue:string) {
			for (var i = 0; i < event.target.files.length; i++) {
				var filetype = event.target.files[i].type;
				if(filetype != 'application/pdf'){
					Swal.fire({
						title: 'Information',
						text: 'Invalid file type. Please upload File with extension: .pdf',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				var size = event.target.files[i].size;
				size = (size / 1024 / 1024);
				if(size > fileSize){
					Swal.fire({
						title: 'Information',
						text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
						icon: 'info',
						customClass: {
							confirmButton: 'btn btn-success'
						}
					});
					return false;
				}
				if(keyValue == 'PMC'){
					this.PMCFiles = [];
					var key = "PMCfile";
					this.PMCFiles.push({ key: key, file: event.target.files[i] });
					this.progressapproveRejectform.controls.PMCdocumentName.setValue(this.showFiles(this.PMCFiles));
				}
				if(keyValue == 'ReleasedOrderCopy'){
					var key = "releasedCopy";
					this.releasedCopyFiles = [];
					this.releasedCopyFiles.push({ key: key, file: event.target.files[i] });
					this.progressapproveRejectform.controls.releasedOrderCopyName.setValue(this.showFiles(this.releasedCopyFiles));
				}
			}
		}

		/**
		 * function save the progress report status.
		 ***/
		approveRejectProgressReport(model) {
			this.submitted = true;
			if ((this.progressapproveRejectform.invalid) || this.isPRFormInvalid ) {
				this.isDisabled = false;
				return false;
			}
			const data = this.prepareSave();
			this.loading = true;
			this._myApplicationService
				.approveRejectProgressData(data).pipe(first())
				.subscribe(
					response => {
						if (Number(response["statusCode"]) === statusCode.SUCCESS) {
							this.isDisabled = false;
							this.submitted = false;
							Swal.fire({
								icon: 'success',
								title: 'Success!',
								text: 'Progress Report status updated successfully.',
								customClass: {
									confirmButton: 'btn btn-success'
								}
							});
							model.close('Accept click');
							this._router.navigate(['/my-application']);
						}
						else {
							//this.error = response["message"];
							this.isDisabled = false;
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: response["message"],
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					},
					error => {
						//this.error = error;
						this.isDisabled = false;
						this.loading = false;
						Swal.fire({
							icon: 'error',
							title: 'Error!',
							text: error,
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				);

			return false;
		}
		public prepareSave(): any {
			let input: FormData = new FormData();
			input.append('applyonlineId', this.progressapproveRejectform.controls.ApplicationID.value);
			input.append('progressReportId', this.progressapproveRejectform.controls.progressReportId.value);
			input.append('PRorderNo', this.progressapproveRejectform.controls.PRorderNo.value);
			input.append('PRamount', this.progressapproveRejectform.controls.PRamount.value);
			
			let releaseDate = this.progressapproveRejectform.controls.PRdate.value;
			if (releaseDate != null && releaseDate != undefined) {
				releaseDate = releaseDate.year + '-' + releaseDate.month + '-' + releaseDate.day;
			}
			input.append("PRdate",releaseDate);
			input.append("reviewReport", this.progressapproveRejectform.controls.SubjectArea.value);
			input.append("PRremarks", this.progressapproveRejectform.controls.PRremarks.value);

			for (var i = 0; i < this.MOMFiles.length; i++) {
				input.append(this.MOMFiles[i].key, this.MOMFiles[i].file);
			}
			
			for (var i = 0; i < this.PMCFiles.length; i++) {
				input.append(this.PMCFiles[i].key, this.PMCFiles[i].file);
			}
			if(this.progressapproveRejectform.controls.SubjectArea.value == 1){
				for (var i = 0; i < this.releasedCopyFiles.length; i++) {
					input.append(this.releasedCopyFiles[i].key, this.releasedCopyFiles[i].file);
				}
			}
			
			return input;
		}
		/**
		 * function use to generate pdf for meeting agenda.
		 ***/
		generateMeetingAgenda() {
			this.applicationIds = this.selectedIDs;
			const data = {
				applyonlineId: this.applicationIds,
			}
			this._myApplicationService.getMeetingAgendaPdf(data).subscribe((result: any) => {
				if (result.statusCode == statusCode.SUCCESS) {
					this.meetingAgendaUrl = result["data"]["response"];
					if(this.meetingAgendaUrl != null && this.meetingAgendaUrl != ""){
						//let meetingURL = "https://" + this.meetingAgendaUrl;
						let meetingURL = this.meetingAgendaUrl.toString();
						window.open(meetingURL);
					}
				}
				else {
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: result["message"],
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			});
		}
		/**
		 * function set application id onchange checkbox.
		 ***/
		selectedIDs: any = [];
		onCheckboxChange(e){
			if (e.target.checked) {
			  	this.selectedIDs.push(e.target.value);
			} else {
			   	const index = this.selectedIDs.findIndex(x=> x == e.target.value);
			   	if(index >= 0){
					this.selectedIDs.splice(index, 1);
			   	}
			}
		}
		downloadMis() {
			let defaultPageSize = this.searchform.controls.PageSize.value != undefined ? this.searchform.controls.PageSize.value : 10;
			let start_Date = this.searchform.controls.StartDate.value;
			if (start_Date != null && start_Date != undefined) {
				start_Date = start_Date.year + '-' + start_Date.month + '-' + start_Date.day;
			}
			let end_Date = this.searchform.controls.EndDate.value;
			if (end_Date != null && end_Date != undefined) {
				end_Date = end_Date.year + '-' + end_Date.month + '-' + end_Date.day;
			}
			const data = {
				projectType: this.searchform.controls.ProjectType.value,
				subject: this.searchform.controls.Subject.value,
				status:this.searchform.controls.Status.value,
				stage: this.searchform.controls.Stage.value,
				searchText: this.searchform.controls.SearchText.value,
				applicationNumber: this.searchform.controls.ApplicationNumber.value,
				principalImplementingOrganizations: this.searchform.controls.PrincipalImplementingOrganizations.value,
				categoryOfInstitution: this.searchform.controls.CategoryOfInstitution.value,
				startDate: start_Date,
				endDate: end_Date,
				sortOrder: (this.searchform.controls.SortOrder.value == null ? "DESC" : this.searchform.controls.SortOrder.value),
				pageNumber: this.previousPage != undefined ? this.previousPage : this.searchform.controls.PageNumber.value,
				pageSize: defaultPageSize,
				isMeetingAgenda : this.fromPageType
			}
			this._myApplicationService.getMISreport(data).subscribe((result: any) => {
				if (result.statusCode == statusCode.SUCCESS) {
					this.misUrl = result["data"]["response"];
					if(this.misUrl != null && this.misUrl != ""){
						//let misURL = "https://" + this.misUrl;
						let misURL = this.misUrl.toString();
						window.open(misURL);
					}
				}
				else {
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: result["message"],
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			});
		}
		/**
		 * function for open model popup for Approve/Reject application.
		 ***/
		profileDataUpdate(modalPU,id) {
			var userId = id;
			this.updateProfileForm.reset();
			this.updateProfileForm.controls.userId.setValue(userId);
			this.modalService.open(modalPU, { size: 'lg', scrollable: false,backdrop:'static'});
		}
		/**
		 * function for save profile data.
		 ***/
		submitProfileData(modal) {
			//modal.close('Accept click');
			this.submitted = true;
			if (this.updateProfileForm.invalid) {
				return false;
			}
			else {
				let DOBData = this.updateProfileForm.controls.dateOfBirth.value;
				let DOB = DOBData.year + '-' + DOBData.month + '-' + DOBData.day;
				const data = {
					title:  this.updateProfileForm.controls.title.value,
					dateOfBirth : this.datePipe.transform(DOB, "yyyy-MM-dd"),
					department : this.updateProfileForm.controls.department.value,
					designation : this.updateProfileForm.controls.designation.value,
					institute:this.updateProfileForm.controls.institute.value,
					userId : this.updateProfileForm.controls.userId.value,
					gender : this.updateProfileForm.controls.gender.value
				}
				this._myApplicationService.submitProfileData(data).pipe(first()).subscribe(
						result => {
							if (Number(result["statusCode"]) === statusCode.SUCCESS) {
								this.submitted = false;
								Swal.fire({
									icon: 'success',
									title: 'Success!',
									text: 'Profile Updated Successfully.',
									customClass: {
										confirmButton: 'btn btn-success'
									}
								});
								modal.close('Accept click');
							}
							else {
								this.loading = false;
								Swal.fire({
									icon: 'info',
									title: 'Info!',
									text: result["message"],
									customClass: {
										confirmButton: 'btn btn-error'
									}
								});
							}
						},
						error => {
							//this.error = error;
							this.loading = false;
							Swal.fire({
								icon: 'error',
								title: 'Error!',
								text: error,
								customClass: {
									confirmButton: 'btn btn-error'
								}
							});
						}
					);
				return false;
			}
		}
		/**
		 * function for get profile data.
		 ***/
		get profileData(){
			return this.updateProfileForm.controls;
		}
		
		/**
		 * function for show/hide div in upload sanction letter.
		 ***/
		toggleShow(buttonType) {
			this.isShown = true;
			this.submitted = false;
			if(buttonType == 'Reject'){
				this.uploadsanctionlatterform.get('Rejectremarks').setValidators([Validators.required]);
				this.uploadsanctionlatterform.get('SanctionLatter').clearValidators();
				this.uploadsanctionlatterform.controls.SanctionLatter.setValue("");
				this.uploadsanctionlatterform.get('orderNo').clearValidators();
				this.uploadsanctionlatterform.controls.orderNo.setValue("");
				this.uploadsanctionlatterform.get('sanctionAmount').clearValidators();
				this.uploadsanctionlatterform.controls.sanctionAmount.setValue("");
				this.uploadsanctionlatterform.get('sanctionDate').clearValidators();
				this.uploadsanctionlatterform.controls.sanctionDate.setValue("");
				this.uploadsanctionlatterform.get('majorDeliverables').clearValidators();
				this.uploadsanctionlatterform.controls.majorDeliverables.setValue("");
				this.uploadsanctionlatterform.get('releaseAmount').clearValidators();
				this.uploadsanctionlatterform.controls.releaseAmount.setValue("");
				this.isShownRemark = true;
				this.isShown = false;
			}
			if(buttonType == 'Accept'){
				this.uploadsanctionlatterform.get('SanctionLatter').setValidators([Validators.required]);
				this.uploadsanctionlatterform.get('orderNo').setValidators([Validators.required]);
				this.uploadsanctionlatterform.get('sanctionAmount').setValidators([Validators.required]);
				this.uploadsanctionlatterform.get('sanctionDate').setValidators([Validators.required]);
				this.uploadsanctionlatterform.controls.majorDeliverables.setValidators([Validators.required]);


				this.uploadsanctionlatterform.get('Rejectremarks').clearValidators();
				this.uploadsanctionlatterform.controls.Rejectremarks.setValue("");

				
				this.isShownRemark = false;
				this.isShown = true;
			}
		}
		/**
		 * function get uploaded file on upload file change.
		 ***/
		// uploadReleasedCopyfileChange(event: any, fileSize:any) {
		// 	for (var i = 0; i < event.target.files.length; i++) {
		// 		var filetype = event.target.files[i].type;
		// 		if(filetype != 'application/pdf'){
		// 			Swal.fire({
		// 				title: 'Information',
		// 				text: 'Invalid file type. Please upload File with extension: .pdf',
		// 				icon: 'info',
		// 				customClass: {
		// 					confirmButton: 'btn btn-success'
		// 				}
		// 			});
		// 			return false;
		// 		}
		// 		var size = event.target.files[i].size;
		// 		size = (size / 1024 / 1024);
		// 		if(size > fileSize){
		// 			Swal.fire({
		// 				title: 'Information',
		// 				text: 'Slected file size is too Big, please select a file less than: ' + fileSize + ' MB:)',
		// 				icon: 'info',
		// 				customClass: {
		// 					confirmButton: 'btn btn-success'
		// 				}
		// 			});
		// 			return false;
		// 		}
		// 		var key = "releasedCopy";
		// 		this.releasedCopyFiles.push({ key: key, file: event.target.files[i] });
		// 		this.progressapproveRejectform.controls.releasedOrderCopyName.setValue(this.showFiles(this.releasedCopyFiles));
		// 	}
		// }
		isFormInvalid: any;
		validationForReleasedAmount(event: any){
			this.isReleasedAmountValid = 0;
			this.sanctionedAmount = parseFloat(this.uploadsanctionlatterform.get('sanctionAmount').value.replaceAll(",",""));
			this.releasedAmount = parseFloat(this.uploadsanctionlatterform.get('releaseAmount').value.replaceAll(",",""));
			if(this.sanctionedAmount >= 0 && (this.releasedAmount > this.sanctionedAmount ) ) {
				this.isFormInvalid = true;
				return false;
			}else{
				this.isFormInvalid = false;
				return true;
			}
		}
		
		validationForReleasedAmountInApproveProgressReport(event: any) {
			this.isReleasedAmountValid = 0;
			this.sanctionedAmount = parseFloat(this.progressapproveRejectform.get('SNamount').value.replaceAll(",",""));
			this.releasedAmount = parseFloat(this.progressapproveRejectform.get('PRamount').value.replaceAll(",",""));
			if(this.sanctionedAmount >= 0 && (this.releasedAmount > this.sanctionedAmount ) ) {
				this.isPRFormInvalid = true;
				return false;
			}else{
				this.isPRFormInvalid = false;
				return true;
			}
		}

		toggleShowReviewReport(buttonType) {
			// this.isShownRejectField = true;
			this.submitted = false;
			if(buttonType == 2){
				this.progressapproveRejectform.get('PRorderNo').clearValidators();
				this.progressapproveRejectform.get('PRamount').clearValidators();
				this.progressapproveRejectform.controls.PRamount.setValue(0);
				this.progressapproveRejectform.get('PRdate').clearValidators();
				this.progressapproveRejectform.controls.PRdate.setValue("");
				this.progressapproveRejectform.get('PRorderNo').clearValidators();
				this.progressapproveRejectform.controls.PRorderNo.setValue("");

				this.progressapproveRejectform.get('MOMdocument').clearValidators();
				this.progressapproveRejectform.controls.MOMdocument.setValue("");
				this.progressapproveRejectform.get('releasedOrderCopy').clearValidators();
				this.progressapproveRejectform.controls.releasedOrderCopy.setValue("");
				this.progressapproveRejectform.get('SubjectArea').clearValidators();
				this.progressapproveRejectform.get('PMCdocument').setValidators([Validators.required]);
				
				this.isShownRejectField = false;
			}else{
				this.progressapproveRejectform.get('PMCdocument').clearValidators();
				this.progressapproveRejectform.controls.PMCdocument.setValue("");
				this.progressapproveRejectform.get('PRorderNo').setValidators([Validators.required]);
				this.progressapproveRejectform.get('PRamount').setValidators([Validators.required]);
				this.progressapproveRejectform.get('PRdate').setValidators([Validators.required]);
				this.progressapproveRejectform.get('MOMdocument').setValidators([Validators.required]);
				this.progressapproveRejectform.get('releasedOrderCopy').setValidators([Validators.required]);
				this.progressapproveRejectform.get('SubjectArea').setValidators([Validators.required]);
				this.progressapproveRejectform.get('PRremarks').setValidators([Validators.required]);

				this.isShownRejectField = true;
			}
		}

		downloadSummaryReport() {
			let defaultPageSize = this.searchform.controls.PageSize.value != undefined ? this.searchform.controls.PageSize.value : 10;
			let start_Date = this.searchform.controls.StartDate.value;
			if (start_Date != null && start_Date != undefined) {
				start_Date = start_Date.year + '-' + start_Date.month + '-' + start_Date.day;
			}
			let end_Date = this.searchform.controls.EndDate.value;
			if (end_Date != null && end_Date != undefined) {
				end_Date = end_Date.year + '-' + end_Date.month + '-' + end_Date.day;
			}
			const data = {
				projectType: this.searchform.controls.ProjectType.value,
				status:this.searchform.controls.Status.value,
				stage: this.searchform.controls.Stage.value,
				subject: this.searchform.controls.Subject.value,
				searchText: this.searchform.controls.SearchText.value,
				applicationNumber: this.searchform.controls.ApplicationNumber.value,
				principalImplementingOrganizations: this.searchform.controls.PrincipalImplementingOrganizations.value,
				categoryOfInstitution: this.searchform.controls.CategoryOfInstitution.value,
				startDate: start_Date,
				endDate: end_Date,
				sortOrder: (this.searchform.controls.SortOrder.value == null ? "DESC" : this.searchform.controls.SortOrder.value),
				pageNumber: this.previousPage != undefined ? this.previousPage : this.searchform.controls.PageNumber.value,
				pageSize: defaultPageSize,
				isMeetingAgenda : this.fromPageType
			}
			this._myApplicationService.downloadSummeryReport(data).subscribe((result: any) => {
				if (result.statusCode == statusCode.SUCCESS) {
					this.summaryReportURL = result["data"];
					if(this.summaryReportURL != null && this.summaryReportURL != ""){
						//let summaryReportURL = "https://" + this.summaryReportURL;
						let summaryReportURL = this.summaryReportURL.toString();
						window.open(summaryReportURL);
					}
				}else {
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: result["message"],
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			});
		}
		/**
		 * function for load subject area
		 ***/
		loadSubjectAreaType() {
			this._commonService.getParameterSettings(ParentParameters.SUBJECTAREA).subscribe((result: any) => {
				this.subjectType = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.subjectType.push({
							subjectTypeName: element.paraDescription,
							subjectTypeID: element.paraId
						});
					});
				}
			});
		}
		/**
		 * function for load subject area
		 ***/
		// subjectChange(subjectTypeIds: any,isEdit){
		// 	if(isEdit){
		// 		this.addExpertForm.controls.department.setValue(this.departmentDataArray);
		// 	}
		// 	const subjectArray = [];
		// 	subjectTypeIds.forEach(element => {
		// 		subjectArray.push(element.subjectTypeID);
		// 	});
		// 	if(subjectArray.length == 0){
		// 		this.addExpertForm.controls.department.setValue('');
		// 		this.addExpertForm.controls.Category.setValue('');
		// 	}
		// 	this._commonService.getDepartmentFromSubject(subjectArray).subscribe((result: any) => {
		// 		this.department = [];
		// 		if (result.statusCode == statusCode.SUCCESS) {
		// 			result["data"]["response"].forEach(element => {
		// 				this.department.push({
		// 					departmentName: element.paraDescription,
		// 					departmentID: element.paraId
		// 				});
		// 			});
		// 		}
		// 	});
		// }

		/**
		 * function for load subject area
		 ***/
		subjectChange(subjectTypeIds: any,isEdit){
			this.CategoryType 		= [];
			var departmentSelectedIds = this.forwordtoexpertform.controls.department.value
			var categorySelectedIds = this.forwordtoexpertform.controls.Category.value
			const subjectArray = [];
			subjectTypeIds.forEach(element => {
				subjectArray.push(element.subjectTypeID);
			});
			this.loadExpertDataNew(subjectArray,Array(),Array(),false);	
			// Category: [, [Validators.required]],
			// 	Expert: [, [Validators.required]],
			// 	Remarks: [, [Validators.required]],
			// 	Subject:[,[Validators.required]],
			// 	department:[,[Validators.required]],
			// 	ApplicationID: []
			if(subjectArray.length == 0){
				this.forwordtoexpertform.controls.department.setValue('');
				this.forwordtoexpertform.controls.Category.setValue('');
				this.forwordtoexpertform.controls.Expert.setValue('');
			}
			this._commonService.getDepartmentFromSubject(subjectArray).subscribe((result: any) => {
				this.department = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.department.push({
							departmentName: element.paraDescription,
							departmentID: element.paraId,
							departmentSubjectId : element.paraParentId
						});
					});
					if(departmentSelectedIds){
						let departmentMap = this.department.map(itemY => { return itemY.departmentID; });
						let filtered = departmentSelectedIds.filter(itemX => { return departmentMap.includes(itemX) });
						this.forwordtoexpertform.controls.department.setValue(filtered);
						
						
						this.departmentChange(filtered,true);
						let categoryMap 		= this.CategoryType.map(itemY => { return itemY.departmentID; });
						let filteredCategory 	= categorySelectedIds.filter(itemX => { return categoryMap.includes(itemX) });
						this.forwordtoexpertform.controls.Category.setValue(filteredCategory);


					}
				}
			});
		}

		// departmentChange(departmentIds:any,isEdit){
		// 	if(isEdit){
		// 		this.addExpertForm.controls.Category.setValue(this.categoryDataArray);
		// 	}
		// 	const departmentArray 	= [];
		// 	departmentIds.forEach(element => {
		// 		departmentArray.push(element.departmentID);
		// 	});
		// 	if(departmentArray.length == 0){
		// 		this.addExpertForm.controls.Category.setValue('');
		// 	}
		// 	this._commonService.getCategoryFromDepartment(departmentArray).subscribe((result: any) => {
		// 		this.CategoryType 		= [];
		// 		if (result.statusCode == statusCode.SUCCESS) {
		// 			result["data"]["response"].forEach(element => {
		// 				this.CategoryType.push({
		// 					categoryTypeName: element.paraDescription,
		// 					categoryTypeID: element.paraId
		// 				});
		// 			});
		// 		}
		// 	});
		// }
		departmentChange(departmentIds:any,isEdit){
			this.categorySelectedIds = this.forwordtoexpertform.controls.Category.value
			this.expertSelectedId 	= this.forwordtoexpertform.controls.Expert.value;
			let departmentArray 	= [];
			if(isEdit){
				departmentArray = departmentIds;
			}else{
				departmentIds.forEach(element => {
					departmentArray.push(element.departmentID);
				});
			}
			this.loadExpertDataNew(this.forwordtoexpertform.controls.Subject.value,departmentArray,Array(),false);
			if(departmentArray.length == 0){
				this.forwordtoexpertform.controls.Category.setValue('');
				this.forwordtoexpertform.controls.Expert.setValue('');
			}
			this._commonService.getCategoryFromDepartment(departmentArray).subscribe((result: any) => {
				this.CategoryType 		= [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.CategoryType.push({
							categoryTypeName: element.paraDescription,
							categoryTypeID: element.paraId
						});
					});
					if(this.categorySelectedIds){
						let categoryMap 		= this.CategoryType.map(itemY => { return itemY.categoryTypeID; });
						let filteredCategory 	= this.categorySelectedIds.filter(itemX => { return categoryMap.includes(itemX) });
						this.forwordtoexpertform.controls.Category.setValue(filteredCategory);
						if(this.expertSelectedId){
							this.loadExpertData(filteredCategory,true);
							let expertMap 	= this.expertListArray.map(item => { return item.categoryId});
							let filteredExpert = this.expertSelectedId.filter(itemZ => { return expertMap.includes(itemZ)})
							this.forwordtoexpertform.controls.Expert.setValue(filteredExpert);
						}
					}
					
				}
			});
		}
		/**
		 * function for load expert dropdown data.
		 ***/
		loadExpertData(expertCategoryId,isEdit) {
			this.expertSelectedId 	= this.forwordtoexpertform.controls.Expert.value;
			let categoryArray 	= [];
			if(isEdit){
				categoryArray = expertCategoryId
			}else{
				expertCategoryId.forEach(element => {
					categoryArray.push(element.categoryTypeID);
				});
			}
			this._commonService.getExpertListData(categoryArray).subscribe((result: any) => {
				this.expertListArray = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.expertListArray.push({
							name: element.name,
							id: element.id,
							categoryId : element.subjectArea,
						});
					});
				}
				if(this.expertSelectedId){
					let expertMap 	= this.expertListArray.map(item => { return item.id});
					let filteredExpert = this.expertSelectedId.filter(itemZ => { return expertMap.includes(itemZ)})
					this.forwordtoexpertform.controls.Expert.setValue(filteredExpert);
				}
			});
		}
		loadExpertDetails(expertCategoryId:any,isEdit){
			this.expertSelectedId 	= this.forwordtoexpertform.controls.Expert.value;
			let categoryArray 	= [];
			if(isEdit){
				categoryArray = expertCategoryId
			}else{
				expertCategoryId.forEach(element => {
					categoryArray.push(element.categoryTypeID);
				});
			}
			this.loadExpertDataNew(this.forwordtoexpertform.controls.Subject.value,this.forwordtoexpertform.controls.department.value,categoryArray,false);
		}
		loadExpertDataNew(expertCategoryId,departmentId,expertiseId,isEdit) {
			this.expertSelectedId 	= this.forwordtoexpertform.controls.Expert.value;
			let categoryArray 		= [];
			// if(isEdit){
			// 	categoryArray = expertCategoryId
			// }else{
			// 	expertCategoryId.forEach(element => {
			// 		categoryArray.push(element.categoryTypeID);
			// 	});
			// }
			
			// expertCategoryId.forEach(element => {
			// 	categoryArray.push(element.subjectTypeID);
			// });
			const data = {
				categoryIDs : expertCategoryId,
				departmentIDs:departmentId,
				expertiseIDs:expertiseId
			}
			this._commonService.getExpertListData(data).subscribe((result: any) => {
				this.expertListArray = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.expertListArray.push({
							name: element.name,
							id: element.id,
							categoryId : element.subjectArea,
						});
					});
				}
				if(this.expertSelectedId){
					let expertMap 	= this.expertListArray.map(item => { return item.id});
					let filteredExpert = this.expertSelectedId.filter(itemZ => { return expertMap.includes(itemZ)})
					this.forwordtoexpertform.controls.Expert.setValue(filteredExpert);
				}
			});
		}
		/*
		*
		*/
		rejectApplicationStatus(){
			this.applicationStatusRemarksubmitted = true;
			if (this.approverejectform.invalid) {
				return false;
			}
			console.log(this.approverejectform.value.ApplicationID);
		}
		acceptApplicationStatus(){
			this.applicationStatusRemarksubmitted = true;
			if (this.approverejectform.invalid) {
				return false;
			}
		}
		updateExpertRemarkStatus(modalEAR,experCommentStatus,expertId){
			this.acceptRejectExpertComments.reset();
			this.expertStatusSubmitted = false;
			this.modalService.open(modalEAR,{ 
				size: 'l',
				scrollable: true,
				centered: true,
				backdrop: 'static',
			});
			this.acceptRejectExpertComments.controls.expertStatus.setValue(experCommentStatus);
			this.acceptRejectExpertComments.controls.expertId.setValue(expertId);
			this.acceptRejectExpertComments.controls.applicationID.setValue(this.approverejectform.value.ApplicationID);
		}
		submitExpertStatusRemark(model,modalAR){
			this.expertStatusSubmitted = true;
			if(this.acceptRejectExpertComments.invalid){
				return false;
			}
			const data = {
				status : this.acceptRejectExpertComments.value.expertStatus,
				expertId : this.acceptRejectExpertComments.value.expertId,
				applicationID : this.acceptRejectExpertComments.value.applicationID,
				remark : this.acceptRejectExpertComments.value.expertCommentsRemark
			}
			this._myApplicationService.updateExpertCommentsStatus(data).pipe(first()).subscribe(
				response => {
					if (Number(response["statusCode"]) === statusCode.SUCCESS) {
						this.isDisabled = false;
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Success!',
							text: 'Expert Comments Status Updated successfully.',
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						model.close('Accept click');
						this.getApplicationDetail(this.approverejectform.value.applicationEncodedID);
					}
					else {
						this.loading = false;
						Swal.fire({
							icon: 'error',
							title: 'Error!',
							text: response["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
				error => {
					//this.error = error;
					this.isDisabled = false;
					this.loading = false;
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: error,
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			);
		}
		acceptRejectExpert(){
			return this.acceptRejectExpertComments.controls;
		}

		getResearchOptionsSelected(getval) {
			var myString = getval;
            this.AreaofResearch = myString.split(',');
			//alert(getval);
			console.log(this.AreaofResearch);
			// let numbers : Array<number>; 
			// numbers = selected;
			// if (numbers.includes(6)) {
			// 	this.selectedOption = 'Others';
			// }
			// this.selectedOption = 'Others';
			//this.AreaofResearch 
			// return this.selectedOption;
				
		}
		
}

